import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_CHARGING_STATION_ACCESS_TYPE = createActionTypes('FETCH_CHARGING_STATION_ACCESS_TYPE');
export const GET_CHARGING_STATION_ACCESS_TYPE = createActionTypes('GET_CHARGING_STATION_ACCESS_TYPE_MAKE');
export const CREATE_CHARGING_STATION_ACCESS_TYPE = createActionTypes('CREATE_CHARGING_STATION_ACCESS_TYPE');
export const UPDATE_CHARGING_STATION_ACCESS_TYPE = createActionTypes('UPDATE_CHARGING_STATION_ACCESS_TYPE');
export const DELETE_CHARGING_STATION_ACCESS_TYPE = createActionTypes('DELETE_CHARGING_STATION_ACCESS_TYPE');
